import Zergling from "../../../../../helpers/zergling";

export const calculateBetBuilderPossibleWin = (stake, price, currencyConfig) => {
  if (!stake) return null;
  const rounding = Math.abs(currencyConfig.rounding);
  const amount = stake * price;
  return parseFloat(amount.toFixed(rounding));
};

export const betBuilderPlaceBet = (bestlipUid, stake, userAuthData) => {
  const params = {
    BetSlipUid: bestlipUid,
    Amount: stake,
  };

  if (userAuthData) {
    params.IsPlayerBetting = true;
    params.ClientId = userAuthData.user_id;
  }

  return Zergling.get(
    {
      name: "CreateBetSC",
      params,
    },
    "betshop_command"
  );
};

export const betBuilderBookingBet = (bestlipUid, stake) =>
  Zergling.get(
    {
      bets: [{ BetSlipUid: bestlipUid, Amount: stake, BetType: 50 }],
    },
    "create_bet_book_v2"
  );
